module.exports = __webpack_public_path__ + "static/media/long-arrow-alt-right.fcda8732.svg";